const Vue = require('vue')

Vue.component('form-file', require('components/std/File.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/file.js